import { useState, useEffect } from 'react';
import { chatService } from '../services/chatService';

interface UseMediaLoaderProps {
  messageType: string;
  mediaId?: string;
  tempMediaUrl?: string;
  tempAudioUrl?: string;
  tempFileUrl?: string;
}

export const useMediaLoader = ({
  messageType,
  mediaId,
  tempMediaUrl,
  tempAudioUrl,
  tempFileUrl
}: UseMediaLoaderProps) => {
  const [mediaUrl, setMediaUrl] = useState<string | undefined>(undefined);

  useEffect(() => {
    let mounted = true;

    const loadMedia = async () => {
      if (['AUDIO', 'IMAGE', 'DOCUMENT', 'FILE'].includes(messageType) && 
          mediaId && !tempMediaUrl && !tempAudioUrl && !tempFileUrl) {
        try {
          const url = await chatService.getMedia(mediaId);
          if (mounted) setMediaUrl(url);
        } catch (error) {
          console.error('Media load error:', error);
        }
      }
    };

    loadMedia();

    return () => {
      mounted = false;
      if (mediaUrl) {
        URL.revokeObjectURL(mediaUrl);
      }
    };
  }, [messageType, mediaId, tempMediaUrl, tempAudioUrl, tempFileUrl, mediaUrl]);

  return {
    mediaUrl,
    isLoading: ['AUDIO', 'IMAGE', 'DOCUMENT', 'FILE'].includes(messageType) && 
               mediaId && !tempMediaUrl && !tempAudioUrl && !tempFileUrl && !mediaUrl
  };
}; 